export const SelectionCard = ({
  id,
  label,
  description,
  selected,
  onSelect,
  testIdPrefix,
}) => {
  return (
    <button
      type="button"
      data-testid={`${testIdPrefix}-${id}`}
      onClick={() => onSelect(id)}
      aria-pressed={selected}
      className={`group relative flex w-full flex-col items-start gap-3 border bg-white p-6 text-left transition-all duration-200 ease-out ${
        selected
          ? "border-foreground shadow-[0_0_0_1px_hsl(var(--foreground))]"
          : "border-border hover:border-foreground/60"
      }`}
    >
      <div className="flex w-full items-start justify-between gap-3">
        <span className="font-serif text-xl font-light leading-tight tracking-tight text-foreground">
          {label}
        </span>
        <span
          className={`mt-1 flex h-4 w-4 shrink-0 items-center justify-center border ${
            selected
              ? "border-foreground bg-foreground"
              : "border-border bg-white group-hover:border-foreground/60"
          }`}
        >
          {selected ? (
            <span className="block h-1.5 w-1.5 bg-white" aria-hidden />
          ) : null}
        </span>
      </div>
      <p className="text-sm leading-relaxed text-muted-foreground">
        {description}
      </p>
    </button>
  );
};
